import type { ItemStatus, StatusType } from "./items";
import type { PrvSchedule } from "./prv";

export enum SupportedAuthenticationMethod {
  ALL = "all",
  PASSWORD = "password",
  SSO = "sso",
}

export enum UnitSystem {
  METRIC = "metric",
  IMPERIAL = "imperial",
}

export interface Client {
  id: number;
  name: string;
  logo?: string;
  slug?: string;
  color?: string;
  address?: string;
  contactEmail?: string;
  website?: string;
  size?: number;
  department?: string;
  fields?: Record<string, unknown>;
  createdAt: Date;
  updatedAt: Date;
  supportedAuthenticationMethods?: SupportedAuthenticationMethod;
  allowedRoutes?: string[];
  visibleColumns?: Record<string, string[]>;
  dateFormat?: string;
  timeFormat?: string;
  allowedStatuses?: ItemStatus[];
  statusTypes?: Record<string, StatusType>;
  geofenceRadius?: number;
  shipmentGapDeltaSeconds?: number;
  unitSystem?: UnitSystem;
  /** PRV Engine config (TMA admin). Defaults: daily, 1000 m, 120 min. */
  prvSchedule?: PrvSchedule;
  prvMinDwellMinutes?: number;
  /** Logistics Prediction settings (TMA admin). Defaults: 240 min, 7, 50 %, 100 %. */
  predictionVisitGapMinutes?: number;
  predictionMinDeliveries?: number;
  predictionRegularSharePercent?: number;
  predictionMaxSpreadPercent?: number;
  /** Routing settings (TMA admin). Defaults: 270 min (4.5 h) and 30 min. */
  predictionGroupingLimitMinutes?: number;
  predictionOffloadingMinutes?: number;
}

export type CreateClientPayload = Omit<Client, "id" | "createdAt" | "updatedAt">;
